<script>
  /**
   * 並んだボタンから一つを選べるラジオボタン
   * - ボタンを選択されたらハンドラ経由で値を渡す
   */
  export let name = ''
  export let options = []
  export let columnSize = null
  export let selectHandler = option => null // オプションを選択されたときのハンドラ
  export let value = null // 選択中の値。指定するとそのボタンをハイライトする。
</script>

<div class="columns is-mobile is-multiline">
  {#each options as option, i}
    <div class={`column${columnSize ? ` is-${columnSize}` : ``}`}>
      <button
        class="button"
        data-testid={`${name}OptionButton-${i}`}
        on:click={selectHandler(option)}
        class:is-success={value === option}
      >
        {option}
      </button>
    </div>
  {/each}
</div>
